import { useState } from "react";
import { Header } from "@/components/Header";
import { MobileBar } from "@/components/MobileBar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { QuickFacts } from "@/components/QuickFacts";
import { Venue } from "@/components/Venue";
import { Evenings } from "@/components/Evenings";
import { MenuSection } from "@/components/MenuSection";
import { Reviews } from "@/components/Reviews";
import { Gallery } from "@/components/Gallery";
import { LocationSection } from "@/components/LocationSection";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";

const CONSENT_KEY = "river-cookie-consent";

export default function Home() {
    const [consent, setConsent] = useState(() => localStorage.getItem(CONSENT_KEY));
    const accept = () => {
        localStorage.setItem(CONSENT_KEY, "accepted");
        setConsent("accepted");
    };
    const reject = () => {
        localStorage.setItem(CONSENT_KEY, "rejected");
        setConsent("rejected");
    };
    const reopen = () => {
        localStorage.removeItem(CONSENT_KEY);
        setConsent(null);
    };
    return (
        <div className="page-with-bar bg-carbone text-avorio min-h-screen" data-testid="home-page">
            <div className="noise-overlay" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <QuickFacts />
                <Venue />
                <Evenings />
                <MenuSection />
                <Reviews />
                <Gallery />
                <LocationSection consent={consent} onLoadMap={accept} />
            </main>
            <Footer onCookiePrefs={reopen} />
            <MobileBar />
            {!consent && <CookieBanner onAccept={accept} onReject={reject} />}
        </div>
    );
}
